module.exports = __webpack_public_path__ + "static/scale-model-of-patterson-house-in-fremont-california-66d4ec9b8be4e45f7127269cd6a467cc.png";